import { useStore } from '@stores';
import { IRequestsHook } from 'models/Hooks/Request';
import { useCallback, useEffect, useRef, useState } from 'react';

export const useRequests = (mobile = false): IRequestsHook & { loadMore: () => void; hasMore: boolean } => {
  const { requestStore } = useStore();
  const { totalCount, requests, skipCount, maxResultCount, loading, setSkipCount, setPageChange } =
    requestStore;

  const mobilePageSize = 3;
  const mobileSkip = useRef(0);
  const [mobileLoading, setMobileLoading] = useState(false);

  useEffect(() => {
    return () => requestStore.clearRequests();
  }, [requestStore]);

  useEffect(() => {
    if (mobile) {
      mobileSkip.current = 0;
      requestStore.clearRequests();
      requestStore.appendAll({ skipCount: 0, maxResultCount: mobilePageSize });
    } else {
      requestStore.getAll({ skipCount, maxResultCount });
    }
  }, [requestStore, mobile ? null : skipCount, mobile ? null : maxResultCount]);

  const items = Array.from(requests.values());
  const hasMore = items.length < totalCount;

  const loadMore = useCallback(() => {
    if (!mobile || mobileLoading || !hasMore) return;
    const nextSkip = mobileSkip.current + mobilePageSize;
    mobileSkip.current = nextSkip;
    setMobileLoading(true);
    requestStore
      .appendAll({ skipCount: nextSkip, maxResultCount: mobilePageSize })
      .then(() => setMobileLoading(false));
  }, [mobile, mobileLoading, hasMore, requestStore]);

  return {
    requests: items,
    totalCount,
    skipCount: mobile ? mobileSkip.current : skipCount,
    loading: mobile ? mobileLoading : loading,
    maxResultCount: mobile ? mobilePageSize : maxResultCount,
    setSkipCount,
    setPageChange,
    loadMore,
    hasMore,
  };
};
